export const capitalize = (text: string) =>
  text.length > 1 ? `${text.charAt(0).toUpperCase()}${text.substr(1)}` : text.toUpperCase();
